'use client';

import {
  UH_CONSENT_COOKIE,
  UH_CONSENT_MAX_AGE_SECONDS,
  parseConsent,
  serializeConsent,
  type ConsentRecord,
  type StoredConsentChoice,
} from 'lib/consent/record';

const COOKIE_CONSENT_KEY = 'COOKIE_CONSENT';

export function readConsentRecord(): ConsentRecord | null {
  if (typeof document === 'undefined') return null;
  const parts = document.cookie.split('; ');
  const row = parts.find((part) => part.startsWith(`${UH_CONSENT_COOKIE}=`));
  if (!row) return null;
  const raw = row.slice(UH_CONSENT_COOKIE.length + 1);
  try {
    return parseConsent(decodeURIComponent(raw));
  } catch {
    return null;
  }
}

export function writeConsentRecord(record: ConsentRecord): void {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${UH_CONSENT_COOKIE}=${encodeURIComponent(serializeConsent(record))};path=/;max-age=${UH_CONSENT_MAX_AGE_SECONDS};SameSite=Lax${secure}`;
  try {
    const blogAllowsAds =
      record.choice === 'accept' ||
      (record.choice === 'custom' && record.categories?.ads === true);
    window.localStorage.setItem(
      COOKIE_CONSENT_KEY,
      JSON.stringify(blogAllowsAds),
    );
  } catch {
    // The blog mirror is best-effort.
  }
}

export function consentChoiceOf(
  record: ConsentRecord | null,
): StoredConsentChoice | 'none' {
  return record?.choice ?? 'none';
}
